import React from 'react'
import ReactDOM from 'react-dom'
import { QueryClient } from 'react-query'
import App from './CompanyExperienceApp'

const reactQueryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
